import Vue from 'vue'
import Router from 'vue-router'
// import productCenter from '../pages/product_center'
import index from '../pages/index'
import aboutUs from '../pages/aboutUs'
import product from '../pages/product'
import userService from '../pages/userService'
import banner1 from '../pages/banner1'
import banner2 from '../pages/banner2'
import wenzhang from '../pages/wenzhang'
import batiao from '../pages/batiao'
import afterSale from '../pages/pagess/afterSale'
import ApplicationPermission from '../pages/pagess/ApplicationPermission'
import privacyPolicy from '../pages/pagess/privacyPolicy'
import gdd101 from '../pages/pagess/gdd101'
import gdd102 from '../pages/pagess/gdd102'
import gdd113 from '../pages/pagess/gdd113'
import gdd117 from '../pages/pagess/gdd117'
import gdd120 from '../pages/pagess/gdd120'
import gdd122 from '../pages/pagess/gdd122'
import gdd124 from '../pages/pagess/gdd124'
import gdd125 from '../pages/pagess/gdd125'
import gdd130 from '../pages/pagess/gdd130'
import gdd131 from '../pages/pagess/gdd131'
import gdd132 from '../pages/pagess/gdd132'
import gdd133 from '../pages/pagess/gdd133'
import gdd134 from '../pages/pagess/gdd134'
import gdd135 from '../pages/pagess/gdd135'
import gdd136 from '../pages/pagess/gdd136'
import gdd137 from '../pages/pagess/gdd137'
import gdd138 from '../pages/pagess/gdd138'
import gdd139 from '../pages/pagess/gdd139'
import gdd140 from '../pages/pagess/gdd140'
import gdd141 from '../pages/pagess/gdd141'
import gdd142 from '../pages/pagess/gdd142'
import gdd143 from '../pages/pagess/gdd143'
import gdd144 from '../pages/pagess/gdd144'
import gdd145 from '../pages/pagess/gdd145'
import gdd146 from '../pages/pagess/gdd146'
import gdd147 from '../pages/pagess/gdd147'
import gdd148 from '../pages/pagess/gdd148'
import gdd149 from '../pages/pagess/gdd149'
import gdd150 from '../pages/pagess/gdd150'
import gdd151 from '../pages/pagess/gdd151'
import gdd152 from '../pages/pagess/gdd152'
import gdd153 from '../pages/pagess/gdd153'
import gdd154 from '../pages/pagess/gdd154'
import gdd155 from '../pages/pagess/gdd155'
import gdd156 from '../pages/pagess/gdd156'
import gdd157 from '../pages/pagess/gdd157'
import gdd158 from '../pages/pagess/gdd158'
import gdd159 from '../pages/pagess/gdd159'
import gdd160 from '../pages/pagess/gdd160'
import gdd161 from '../pages/pagess/gdd161'
import gdd162 from '../pages/pagess/gdd162'
import gdd301 from '../pages/pagess/gdd301'
import mOfficial from '../pages/mOfficial/index'
import mobile_gdd101 from '../pages/pagess/mobile/gdd101'
import m_gdd102 from '../pages/pagess/mobile/gdd102'
import aboutUs_mobile from '../pages/pagess/mobile/aboutUs_mobile'



// 市场部页面
import market101 from '../pages/market/market101'
import market102 from '../pages/market/market102'
import market103 from '../pages/market/market103'
import market104 from '../pages/market/market104'
import market105 from '../pages/market/market105'
import market106 from '../pages/market/market106'
import market107 from '../pages/market/market107'
import market108 from '../pages/market/market108'
import market109 from '../pages/market/market109'
import market110 from '../pages/market/market110'
import market103_success from '../pages/market/market103_success'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
	{
	  path: '/batiao',
	  name: 'batiao',
	  component: batiao
	},
    {
      path: '/wenzhang',
      name: 'wenz',
      component: wenzhang
    },
    //banner1
    {
      path: '/mOfficial',
      name: 'mOfficial',
      component: mOfficial
    },
    //banner1
    {
      path: '/banner1',
      name: 'banner1',
      component: banner1
    },
    //banner2
    {
      path: '/banner2',
      name: 'banner2',
      component: banner2
    },
    //应用权限
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },
    //应用权限
    {
      path: '/ApplicationPermission',
      name: 'ApplicationPermission',
      component: ApplicationPermission
    },




    {
      path: '/',
      name: 'index',
      component: index
    },
    // {
    //     path: '/productCenter',
    //     name: 'productCenter',
    //     component: productCenter
    // },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    }, {
      path: '/product',
      name: 'product',
      component: product
    }, {
      path: '/userService',
      name: 'userService',
      component: userService
    }, {
      path: '/gdd101',
      name: 'gdd101',
      component: gdd101
    },
    {
      path: '/gdd102',
      name: 'gdd102',
      component: gdd102
    },

    {
      path: '/gdd113',
      name: 'gdd113',
      component: gdd113
    },
    //第二版设计顶部带按钮页面  上海推广用   cf1  gdd2001
    {
      path: '/gdd117',
      name: 'gdd117',
      component: gdd117
    },
    //   360 大搜下载按钮点击
    {
      path: '/gdd122',
      name: 'gdd122',
      component: gdd122
    },
    //   360 展示广告投放  gdd1001
    {
      path: '/gdd120',
      name: 'gdd120',
      component: gdd120
    },
    //360 12号账户  展示广告  下载    2001的包
    {
      path: '/gdd124',
      name: 'gdd124',
      component: gdd124
    }, //360 12号账户  展示广告  下载    2002的包
    {
      path: '/gdd125',
      name: 'gdd125',
      component: gdd125
    }, {
      path: '/gdd130',
      name: 'gdd130',
      component: gdd130
    }, {
      path: '/gdd131',
      name: 'gdd131',
      component: gdd131
    }, {
      path: '/gdd132',
      name: 'gdd132',
      component: gdd132
    }, {
      path: '/gdd133',
      name: 'gdd133',
      component: gdd133
    }, {
      path: '/gdd134',
      name: 'gdd134',
      component: gdd134
    }, {
      path: '/gdd135',
      name: 'gdd135',
      component: gdd135
    }, {
      path: '/gdd136',
      name: 'gdd136',
      component: gdd136
    }, {
      path: '/gdd137',
      name: 'gdd137',
      component: gdd137
    }, {
      path: '/gdd138',
      name: 'gdd138',
      component: gdd138
    }, {
      path: '/gdd139',
      name: 'gdd139',
      component: gdd139
    }, {
      path: '/gdd140',
      name: 'gdd140',
      component: gdd140
    }, {
      path: '/gdd141',
      name: 'gdd141',
      component: gdd141
    }, {
      path: '/gdd142',
      name: 'gdd142',
      component: gdd142
    }, {
      path: '/gdd143',
      name: 'gdd143',
      component: gdd143
    }, {
      path: '/gdd144',
      name: 'gdd144',
      component: gdd144
    }, {
      path: '/gdd145',
      name: 'gdd145',
      component: gdd145
    }, {
      path: '/gdd146',
      name: 'gdd146',
      component: gdd146
    }, {
      path: '/gdd147',
      name: 'gdd147',
      component: gdd147
    }, {
      path: '/gdd148',
      name: 'gdd148',
      component: gdd148
    }, {
      path: '/gdd149',
      name: 'gdd149',
      component: gdd149
    }, {
      path: '/gdd150',
      name: 'gdd150',
      component: gdd150
    }, {
      path: '/gdd151',
      name: 'gdd151',
      component: gdd151
    }, {
      path: '/gdd152',
      name: 'gdd152',
      component: gdd152
    }, {
      path: '/gdd153',
      name: 'gdd153',
      component: gdd153
    }, {
      path: '/gdd154',
      name: 'gdd154',
      component: gdd154
    }, {
      path: '/gdd155',
      name: 'gdd155',
      component: gdd155
    }, {
      path: '/gdd156',
      name: 'gdd156',
      component: gdd156
    }, {
      path: '/gdd157',
      name: 'gdd157',
      component: gdd157
    }, {
      path: '/gdd158',
      name: 'gdd158',
      component: gdd158
    }, {
      path: '/gdd159',
      name: 'gdd159',
      component: gdd159
    }, {
      path: '/gdd160',
      name: 'gdd160',
      component: gdd160
    }, {
      path: '/gdd161',
      name: 'gdd161',
      component: gdd161
    }, {
      path: '/gdd162',
      name: 'gdd162',
      component: gdd162
    },
    {
      path: '/mobile_gdd101',
      name: 'mobile_gdd101',
      component: mobile_gdd101
    },
    {
      path: '/m_gdd102',
      name: 'm_gdd102',
      component: m_gdd102
    },
    // 移动端关于我们页面
    {
      path: '/aboutUs_mobile',
      name: 'aboutUs_mobile',
      component: aboutUs_mobile
    },

    // 售后页面
    {
      path: '/afterSale',
      name: 'afterSale',
      component: afterSale
    }, {
      path: '/gdd301',
      name: 'gdd301',
      component: gdd301
    },
    // 市场部页面
    {
      path: '/market101',
      name: 'market101',
      component: market101
    }, {
      path: '/market102',
      name: 'market102',
      component: market102
    }, {
      path: '/market103',
      name: 'market103',
      component: market103
    }, {
      path: '/market103_success',
      name: 'market103_success',
      component: market103_success
    }, {
      path: '/market104',
      name: 'market104',
      component: market104
    }, {
      path: '/market105',
      name: 'market105',
      component: market105
    }, {
      path: '/market106',
      name: 'market106',
      component: market106
    }, {
      path: '/market107',
      name: 'market107',
      component: market107
    }, {
      path: '/market108',
      name: 'market108',
      component: market108
    }, {
      path: '/market109',
      name: 'market109',
      component: market109
    }, {
      path: '/market110',
      name: 'market110',
      component: market110
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }

})



// WEBPACK FOOTER //
// ./src/router/index.js